import { render, staticRenderFns } from "./ConfigCompanyIcon.vue?vue&type=template&id=3b5a6272"
import script from "./ConfigCompanyIcon.vue?vue&type=script&lang=js"
export * from "./ConfigCompanyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports